/**
 * Browser entrypoint for the HIP-3 frontend.
 */

import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { Analytics } from "@vercel/analytics/react";

const elem = document.getElementById("root")!;

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchInterval: 30_000,
        refetchOnWindowFocus: false,
        retry: 1,
        retryDelay: 1_500,
      },
    },
  });

let queryClient = createQueryClient();

if (import.meta.hot) {
  const saved = import.meta.hot.data.queryClient as QueryClient | undefined;
  if (saved) {
    queryClient = saved;
  }

  import.meta.hot.dispose((data) => {
    data.queryClient = queryClient;
  });
}

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <Analytics />
    </QueryClientProvider>
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
